import { Injectable } from '@angular/core';
import { SyncOperation } from '@app/core';
import { GenericService, Utils } from '@messaia/cdk';
import { Observable } from 'rxjs';
import { Bill } from '../models/bill';

@Injectable({ providedIn: 'root' })
export class BillService extends GenericService<Bill> {

	/**
	 * Constructor
	 */
	constructor() {
		super('bill');
	}

	/**
	 * Prepares a new bill for the specified customer
	 * @param bill
	 */
	public prepare(bill: Bill): Observable<Bill> {
		return this.create(bill, '/prepare');
	}

	/**
	 * Get bill years
	 */
	public getYears(): Observable<number[]> {
		return this.getList(null, '/years');
	}

	/**
	 * Schedules a sync for the item with the specified ID
	 * @param id 
	 * @param operation 
	 */
	public scheduleItemSync(id: number, operation: SyncOperation) {
		return this.update(`scheduleSync/${id}/${operation}`, null);
	}

	/**
	 * Schedules a sync for the items with the specified ids
	 * @param ids 
	 * @param operation 
	 */
	public scheduleItemsSync(ids: number[], operation: SyncOperation) {
		return this.update(`scheduleSync`, null, null, { params: Utils.toHttpParams({ ids: ids, operation: operation }) });
	}
}